export default __webpack_public_path__ + "static/assets/im_menu.062e6b19815e1a902e4b47889fc24ada.png";